module.exports = __webpack_public_path__ + "static/media/IMG-3.ed0ab134.jpg";